/*!
 * jQuery Workflow Steps Plugin 0.1.0
 * (not yet public)
 *
 * For internal use at SmileBack, all rights reserved.
 * Copyright 2017.
 *
 * Date: 23-01-2017
 */

(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], function ($) {
      return factory($);
    });
  } else if (typeof module === 'object' && typeof module.exports === 'object') {
    // Node-like environment
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(window.jQuery);
  }
}(function($) {
    var SELECTOR_CONTINUE = '.steps-continue',
        SELECTOR_OVERLAY = '.overlay',
        CLASS_INACTIVE = 'inactive',
        CLASS_ACTIVE = 'active',
        CLASS_SUCCESS = 'success';

    function workflow_step(idx, steps, $node) {
        return function() {
            $node.find(SELECTOR_CONTINUE).on('click', function() {
                //console.log('Clicked continue button of step ' + idx);

                steps.successfulStep(idx);
                steps.activateStep(idx + 1);
                steps.scrollTo(idx + 1);
            });

            $node.find(SELECTOR_OVERLAY).on('click', function() {
                if ($node.hasClass(CLASS_INACTIVE) && $node.hasClass(CLASS_SUCCESS)) {
                    console.log('Re-activating step ' + idx);
                    steps.activateStep(idx);
                }
            });

            // TODO Re-activate successful step on click inside

            function _activate() {
                $node.removeClass(CLASS_INACTIVE);
                $node.removeClass(CLASS_SUCCESS);
                $node.addClass(CLASS_ACTIVE);
            }

            function _inactivate() {
                $node.addClass(CLASS_INACTIVE);
                $node.removeClass(CLASS_SUCCESS);
                $node.removeClass(CLASS_ACTIVE);
            }

            function _success() {
                $node.removeClass(CLASS_ACTIVE);
                $node.addClass(CLASS_INACTIVE);
                $node.addClass(CLASS_SUCCESS);
            }

            function _scrollTo() {
                $('html, body').animate({
                    scrollTop: $node.offset().top + -20
                }, 500);
            }

            return {
                activate: _activate,
                inactivate: _inactivate,
                success: _success,
                scrollTo: _scrollTo
            };
        }
    }

    $.fn.workflowSteps = function(options) {
        var $_container = this,
            _onComplete = undefined,
            _onBack = undefined,
            steps = [],
            api = {
                activateStep: function(idx) {
                    if (steps && steps.length > idx) {
                        steps[idx].activate();
                    }
                    if (steps && steps.length > (idx + 1)) {
                        for (var i = idx + 1; i < steps.length; i++) {
                            steps[i].inactivate();
                        }
                    }
                    if(steps[idx]) steps[idx].scrollTo();
                },
                successfulStep: function(idx) {
                    if (numberOfSteps() > idx) {
                        steps[idx].success();
                    }
                    if (idx === numberOfSteps() - 1) {
                        _onComplete();
                    }
                },
                scrollTo: function(idx) {
                    if (steps && steps.length > idx) {
                        steps[idx].scrollTo();
                    }
                },
                onBack: function() {
                    this.activateStep(numberOfSteps() - 1);
                    return this;
                }
            };

        if (options) {
            if (options.steps && options.steps.length > 0) {
                for (var i = 0; i < options.steps.length; i++) {
                    var selector = options.steps[i];
                    addStep(selector);
                }
            } else {
                console.log('Missing configuration option: "steps". '
                    + 'Please provide jQuery selectors for each step: $(...).workflowSteps({ steps: [\'#step-1\', \'#step-2\', \'#step-3\'] });');
            }

            onComplete(options.onComplete);
        }

        function numberOfSteps() {
            return steps ? steps.length : 0;
        }

        function addStep(selector) {
            var $node = $_container.find(selector),
                newStep = workflow_step(steps.length, api, $node)();

            steps.push(newStep);
            steps[0].activate();
            return api;
        }

        function onComplete(cb) {
            _onComplete = function() {
                if (cb && $.isFunction(cb)) {
                    cb();
                }
            }
            return api;
        }

        return api;
    }
}));
